import { Event, PagePageDynamicDynamicZone, Technology, Testimony } from '../../../types/schema';

import { AvailableJobItemProps } from '../../ui/AvailableJobItem';
import DynamicZones from '../DynamicZones';
import { Wrapper } from './styles';

type CustomPageTemplateProps = {
  technologies: Technology[];
  testimonies: Testimony[];
  events: Event[];
  pageDynamic: PagePageDynamicDynamicZone[];
  jobs?: AvailableJobItemProps[];
  language?: string;
};

const CustomPageTemplate: React.FC<CustomPageTemplateProps> = ({
  pageDynamic,
  technologies,
  testimonies,
  jobs,
  events,
  language,
}) => {
  const hasBanner = !!pageDynamic?.find((dz) => dz.__typename === 'ComponentComponentsBanner');

  return (
    <Wrapper style={!hasBanner ? { marginTop: 0 } : {}}>
      {pageDynamic && pageDynamic.length > 0 && (
        <DynamicZones
          dynamicZones={pageDynamic}
          allTechnologies={technologies}
          allTestimonies={testimonies}
          allEvents={events}
          jobs={jobs}
          language={language}
          isCustomPage
        />
      )}
    </Wrapper>
  );
};

export default CustomPageTemplate;
